import React from 'react';

import { customerTypes } from './actions'
import { offerTypes, setMultiState } from '../offers/actions'
import { makeContractsByKennitala, getPersonTypeByAge } from '../../utils'
import { nationalRegistryTypes } from '../national-registry/actions';
const kennitala = require('kennitala')



const createDefaultCustomerObject = (id, name, type) => {
    return {
        Customer: {
            AccountNum: id,
            Contracts: [],
            Name: name
        }, 
        Contracts: {
            Contract: [],
        },
        ContractsByKennitala: {
            [id]: {}
        },
        type: type
    }
}

const initialState = {
    isFetching: false,
    customerList: [],
    lastLookup: {},
    peopleByKennitala: {},
    errorMessage: "",
}


export function customers(state = initialState, action) {
    let existing = null


    switch(action.type) {

        case offerTypes.CLEAR_PERSON:

            state = {...state}
        
            for(let c of state.customerList) {
                    state.customerList = state.customerList.filter(c => {return c.Customer.AccountNum !== action.customerId})
            }

            return state
        
        case customerTypes.ADD_EMPTY:

            state = {...state}

            let _personType = getPersonTypeByAge(action.person.OrgId)

            let customer = Object.assign({}, createDefaultCustomerObject(action.person.OrgId, action.person.Name, _personType))

            existing = state.customerList.find(item => item.Customer.AccountNum === action.person.OrgId)

            if (!existing) {
                state.customerList.push(customer)
            }

            state.peopleByKennitala[action.person.OrgId] = action.person.Name

            return state

        case customerTypes.REQUEST:
            state = {...state}
            state.errorMessage = ""
            state.isFetching = true
            state.lastLookup = {}
            return state

        case customerTypes.RECEIVE:
            state = {...state, isFetching: false, errorMessage: ""}

            let customerObject = {}

            customerObject.Customer = action.data.Customer
            customerObject.Contracts = action.data.Customer.Contracts
            let ContractsByKennitala = makeContractsByKennitala(action.data.Customer.Contracts)

            if (action.data.Customer.Contracts === null) {
                action.data.Customer.Contracts = {Contract: []}
            }

            for(var contract of action.data.Customer.Contracts.Contract) {
                state.peopleByKennitala[contract.CustAccount] = contract.CustName
            }

            customerObject.ContractsByKennitala = ContractsByKennitala

            let personType = getPersonTypeByAge(customerObject.Customer.AccountNum)
            customerObject.type = personType

            if (customerObject.Contracts === null) {
                customerObject = createDefaultCustomerObject(action.data.Customer.AccountNum, action.data.Customer.Name, personType)
                state.peopleByKennitala[action.data.Customer.AccountNum] = action.data.Customer.Name
            }

            existing = state.customerList.find(item => item.Customer.AccountNum === action.data.Customer.AccountNum)

            if (!existing) {
                state.customerList.push(customerObject)
                state.lastLookup = customerObject
            } else {
                let others = state.customerList.filter(item => item.Customer.AccountNum !== action.data.Customer.AccountNum)
                others.push(customerObject)
                state.customerList = others
            }

            return state

        case nationalRegistryTypes.RECEIVE:

            state = {...state}

            if (action.data.length > 0) {
                let person = action.data[0].NationalRegistry
                if (kennitala.info(person.OrgId).age < 18) {
                    let family = []
                    if (person.FamilyList) {
                        family = person.FamilyList.Family
                    }
                    family = family.map(f => {
                        state.peopleByKennitala[f.OrgId] = f.Name
                    })

                }
            }

            return state

        case customerTypes.ERROR:
            state = {...state, isFetching: false}

            state.errorMessage = action.error

            return state
        
        case customerTypes.ADD_TO_PPL_BY_KT:
            state = {...state}
            action.data.map((d) => state.peopleByKennitala[d['NationalRegistry'].OrgId] = d['NationalRegistry'].Name)

            return state

        default:
            return state
    }
}



export function customerPayers(state = initialState, action) {
    let existing = null


    switch(action.type) {


        case customerTypes.REQUEST_PAYER:
            state = {...state}
            state.errorMessage = ""
            state.isFetching = true
            state.lastLookup = {}
            return state

        case customerTypes.RECEIVE_PAYER:
            state = {...state, isFetching: false, errorMessage: ""}

            let customerObject = {}

            customerObject.Customer = action.data.Customer
            customerObject.Contracts = action.data.Customer.PaymInvoiceContracts
            let ContractsByKennitala = makeContractsByKennitala(action.data.Customer.PaymInvoiceContracts)

            if (action.data.Customer.PaymInvoiceContracts === null) {
                action.data.Customer.PaymInvoiceContracts = {Contract: []}
            }

            for(var contract of action.data.Customer.PaymInvoiceContracts.Contract) {
                state.peopleByKennitala[contract.CustAccount] = contract.CustName
            }

            customerObject.ContractsByKennitala = ContractsByKennitala

            let personType = getPersonTypeByAge(customerObject.Customer.AccountNum)
            customerObject.type = personType

            if (customerObject.Contracts === null) {
                customerObject = createDefaultCustomerObject(action.data.Customer.AccountNum, action.data.Customer.Name, personType)
                state.peopleByKennitala[action.data.Customer.AccountNum] = action.data.Customer.Name
            }

            existing = state.customerList.find(item => item.Customer.AccountNum === action.data.Customer.AccountNum)

            if (!existing) {
                state.customerList.push(customerObject)
                state.lastLookup = customerObject
            } else {
                let others = state.customerList.filter(item => item.Customer.AccountNum !== action.data.Customer.AccountNum)
                others.push(customerObject)
                state.customerList = others
            }

            return state

        case nationalRegistryTypes.RECEIVE:

            state = {...state}

            if (action.data.length > 0) {
                let person = action.data[0].NationalRegistry
                if (kennitala.info(person.OrgId).age < 18) {
                    let family = []
                    if (person.FamilyList) {
                        family = person.FamilyList.Family
                    }
                    family = family.map(f => {
                        state.peopleByKennitala[f.OrgId] = f.Name
                    })

                }
            }

            return state

        case customerTypes.ERROR_PAYER:
            state = {...state, isFetching: false}

            state.errorMessage = action.error

            return state
        

        default:
            return state
    }
}